function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M200.229 155.155L4.26094 268.311C2.43414 269.372 0.960938 268.252 0.960938 265.806V120.354C0.960938 117.908 2.43414 115.08 4.26094 114.019L200.229 0.863224C202.055 -0.197609 203.529 0.922159 203.529 3.36797V148.82C203.558 151.266 202.055 154.095 200.229 155.155Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M203.559 21.8125L0.961426 138.799V120.382C0.961426 117.936 2.43463 115.107 4.26142 114.046L200.229 0.890568C202.056 -0.170265 203.529 0.949503 203.529 3.39531V21.8125H203.559Z",
  fill: "#14B86E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M173.27 28.5919C173.27 30.5662 171.856 33.012 170.147 34.0139C168.408 35.0158 167.023 34.2202 167.023 32.2164C167.023 30.2421 168.438 27.7963 170.147 26.7944C171.856 25.7925 173.27 26.5881 173.27 28.5919Z",
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M183.347 22.7568C183.347 24.7311 181.933 27.1769 180.224 28.1788C178.485 29.1807 177.101 28.3851 177.101 26.3813C177.101 24.4069 178.515 21.9611 180.224 20.9592C181.933 19.9868 183.347 20.7824 183.347 22.7568Z",
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M193.424 16.9517C193.424 18.9261 192.01 21.3719 190.301 22.3738C188.563 23.3757 187.178 22.5801 187.178 20.5763C187.178 18.6019 188.592 16.1561 190.301 15.1542C192.01 14.1523 193.424 14.948 193.424 16.9517Z",
  fill: "url(#paint3_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M145.839 48.0107L33.7266 112.751C32.2239 113.605 31.0159 112.692 31.0159 110.718C31.0159 108.743 32.2239 106.415 33.7266 105.561L145.868 40.8206C147.371 39.966 148.579 40.8795 148.579 42.8538C148.549 44.8576 147.341 47.1561 145.839 48.0107Z",
  fill: "url(#paint4_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4109 179.584L26.0635 206.34C23.2644 207.961 20.9956 206.252 20.9956 202.509V151.206C20.9956 147.464 23.2644 143.132 26.0635 141.511L72.4109 114.755C75.21 113.134 77.4788 114.843 77.4788 118.586V169.918C77.4788 173.631 75.21 177.963 72.4109 179.584Z",
  fill: "#14B86E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 52.4904L92.063 105.797V103.41L184.375 50.1035V52.4904Z",
  fill: "#14B86E"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 60.1818L92.063 113.489V111.102L184.375 57.7949V60.1818Z",
  fill: "#14B86E"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 67.8437L92.063 121.151V118.793L184.375 65.4863V67.8437Z",
  fill: "#14B86E"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 75.5334L92.063 128.84V126.453L184.375 73.1465V75.5334Z",
  fill: "#14B86E"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 83.2257L92.063 136.533V134.146L184.375 80.8389V83.2257Z",
  fill: "#14B86E"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M128.805 122.977L92.063 144.193V141.836L128.805 120.619V122.977Z",
  fill: "#14B86E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 108.243L92.063 161.55V159.193L184.375 105.886V108.243Z",
  fill: "#14B86E"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 115.935L92.063 169.242V166.855L184.375 113.548V115.935Z",
  fill: "#14B86E"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 123.625L92.063 176.932V174.545L184.375 121.238V123.625Z",
  fill: "#14B86E"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 131.286L92.063 184.593V182.236L184.375 128.929V131.286Z",
  fill: "#14B86E"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M184.375 138.978L92.063 192.285V189.898L184.375 136.591V138.978Z",
  fill: "#14B86E"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M128.805 178.758L92.063 199.975V197.588L128.805 176.372V178.758Z",
  fill: "#14B86E"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4109 211.32L26.0635 238.077C23.2644 239.698 20.9956 237.989 20.9956 234.246V226.437C20.9956 222.695 23.2644 218.363 26.0635 216.743L72.4109 189.957C75.21 188.336 77.4788 190.045 77.4788 193.787V201.596C77.4788 205.368 75.21 209.7 72.4109 211.32Z",
  fill: "#14B86E"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M266.943 202.474L70.9753 315.629C69.1485 316.69 67.6753 315.57 67.6753 313.124V167.673C67.6753 165.227 69.1485 162.398 70.9753 161.337L266.943 48.1816C268.77 47.1208 270.243 48.2405 270.243 50.6863V196.138C270.273 198.584 268.77 201.413 266.943 202.474Z",
  fill: "url(#paint5_linear)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M270.272 69.1309L67.6748 186.117V167.7C67.6748 165.254 69.148 162.425 70.9748 161.364L266.943 48.2089C268.769 47.1481 270.243 48.2679 270.243 50.7137V69.1309H270.272Z",
  fill: "#14B86E"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M239.983 75.9107C239.983 77.8851 238.568 80.3309 236.86 81.3328C235.121 82.3347 233.736 81.539 233.736 79.5352C233.736 77.5609 235.151 75.1151 236.86 74.1132C238.568 73.1113 239.983 73.9069 239.983 75.9107Z",
  fill: "url(#paint6_linear)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M250.06 70.0761C250.06 72.0504 248.646 74.4962 246.937 75.4981C245.198 76.5 243.813 75.7044 243.813 73.7006C243.813 71.7263 245.228 69.2805 246.937 68.2786C248.646 67.3061 250.06 68.1018 250.06 70.0761Z",
  fill: "url(#paint7_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M260.137 64.2711C260.137 66.2454 258.723 68.6912 257.014 69.6931C255.275 70.695 253.891 69.8994 253.891 67.8956C253.891 65.9213 255.305 63.4755 257.014 62.4736C258.723 61.4717 260.137 62.2673 260.137 64.2711Z",
  fill: "url(#paint8_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M212.552 95.33L100.44 160.07C98.9376 160.925 97.7295 160.011 97.7295 158.037C97.7295 156.063 98.9376 153.735 100.44 152.88L212.582 88.1399C214.084 87.2853 215.292 88.1988 215.292 90.1732C215.263 92.177 214.055 94.4754 212.552 95.33Z",
  fill: "url(#paint9_linear)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M139.125 226.902L92.7773 253.659C89.9782 255.28 87.7095 253.571 87.7095 249.828V198.525C87.7095 194.783 89.9782 190.451 92.7773 188.83L139.125 162.074C141.924 160.453 144.193 162.162 144.193 165.904V217.237C144.193 220.95 141.924 225.282 139.125 226.902Z",
  fill: "#14B86E"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M251.089 99.8087L158.777 153.116V150.729L251.089 97.4219V99.8087Z",
  fill: "#14B86E"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 107.5L158.778 160.807V158.42L251.09 105.113V107.5Z",
  fill: "#14B86E"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 115.162L158.778 168.469V166.112L251.09 112.805V115.162Z",
  fill: "#14B86E"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 122.852L158.778 176.159V173.772L251.09 120.465V122.852Z",
  fill: "#14B86E"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 130.544L158.778 183.851V181.464L251.09 128.157V130.544Z",
  fill: "#14B86E"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M195.52 170.295L158.778 191.512V189.155L195.52 167.938V170.295Z",
  fill: "#14B86E"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M251.089 155.562L158.777 208.869V206.511L251.089 153.205V155.562Z",
  fill: "#14B86E"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 163.253L158.778 216.56V214.173L251.09 160.866V163.253Z",
  fill: "#14B86E"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 170.944L158.778 224.25V221.863L251.09 168.557V170.944Z",
  fill: "#14B86E"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 178.605L158.778 231.912V229.554L251.09 176.248V178.605Z",
  fill: "#14B86E"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M251.09 186.297L158.778 239.603V237.216L251.09 183.91V186.297Z",
  fill: "#14B86E"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M195.52 226.077L158.778 247.294V244.907L195.52 223.69V226.077Z",
  fill: "#14B86E"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M139.125 258.639L92.7773 285.396C89.9782 287.017 87.7095 285.307 87.7095 281.565V273.756C87.7095 270.014 89.9782 265.682 92.7773 264.061L139.125 237.275C141.924 235.655 144.193 237.364 144.193 241.106V248.915C144.193 252.687 141.924 257.019 139.125 258.639Z",
  fill: "#14B86E"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M333.657 249.792L137.69 362.948C135.863 364.008 134.39 362.889 134.39 360.443V214.991C134.39 212.545 135.863 209.716 137.69 208.655L333.657 95.4999C335.484 94.4391 336.957 95.5589 336.957 98.0047V243.457C336.987 245.902 335.484 248.731 333.657 249.792Z",
  fill: "url(#paint10_linear)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M336.987 116.449L134.39 233.436V215.018C134.39 212.573 135.863 209.744 137.69 208.683L333.657 95.5273C335.484 94.4665 336.957 95.5862 336.957 98.032V116.449H336.987Z",
  fill: "#14B86E"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M306.7 123.229C306.7 125.203 305.285 127.649 303.576 128.651C301.838 129.653 300.453 128.857 300.453 126.854C300.453 124.879 301.867 122.433 303.576 121.432C305.285 120.43 306.7 121.225 306.7 123.229Z",
  fill: "url(#paint11_linear)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M316.777 117.394C316.777 119.368 315.363 121.814 313.654 122.816C311.915 123.818 310.53 123.022 310.53 121.018C310.53 119.044 311.945 116.598 313.654 115.596C315.363 114.624 316.777 115.42 316.777 117.394Z",
  fill: "url(#paint12_linear)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M326.854 111.589C326.854 113.563 325.44 116.009 323.731 117.011C321.992 118.013 320.607 117.217 320.607 115.213C320.607 113.239 322.022 110.793 323.731 109.791C325.44 108.79 326.854 109.585 326.854 111.589Z",
  fill: "url(#paint13_linear)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M279.268 142.648L167.156 207.388C165.653 208.243 164.445 207.329 164.445 205.355C164.445 203.381 165.653 201.053 167.156 200.198L279.297 135.458C280.8 134.603 282.008 135.517 282.008 137.491C281.979 139.495 280.771 141.793 279.268 142.648Z",
  fill: "url(#paint14_linear)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M205.84 274.221L159.493 300.977C156.694 302.598 154.425 300.889 154.425 297.147V245.843C154.425 242.101 156.694 237.769 159.493 236.149L205.84 209.392C208.639 207.771 210.908 209.48 210.908 213.223V264.555C210.908 268.268 208.639 272.6 205.84 274.221Z",
  fill: "#14B86E"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 147.127L225.493 200.434V198.047L317.805 144.74V147.127Z",
  fill: "#14B86E"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 154.818L225.493 208.125V205.738L317.805 152.431V154.818Z",
  fill: "#14B86E"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 162.479L225.493 215.786V213.429L317.805 160.122V162.479Z",
  fill: "#14B86E"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 170.171L225.493 223.477V221.091L317.805 167.784V170.171Z",
  fill: "#14B86E"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 177.861L225.493 231.168V228.781L317.805 175.475V177.861Z",
  fill: "#14B86E"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M262.235 217.613L225.493 238.83V236.472L262.235 215.256V217.613Z",
  fill: "#14B86E"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 202.88L225.493 256.187V253.829L317.805 200.522V202.88Z",
  fill: "#14B86E"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 210.571L225.493 263.878V261.491L317.805 208.185V210.571Z",
  fill: "#14B86E"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 218.262L225.493 271.569V269.182L317.805 215.875V218.262Z",
  fill: "#14B86E"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 225.923L225.493 279.23V276.872L317.805 223.565V225.923Z",
  fill: "#14B86E"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M317.805 233.614L225.493 286.921V284.534L317.805 231.228V233.614Z",
  fill: "#14B86E"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M262.235 273.395L225.493 294.612V292.225L262.235 271.008V273.395Z",
  fill: "#14B86E"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M205.84 305.957L159.493 332.714C156.694 334.334 154.425 332.625 154.425 328.883V321.074C154.425 317.332 156.694 313 159.493 311.379L205.84 284.593C208.639 282.973 210.908 284.682 210.908 288.424V296.233C210.908 300.005 208.639 304.336 205.84 305.957Z",
  fill: "#14B86E"
});

var _ref62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 50.8779,
  y1: 43.8286,
  x2: 263.041,
  y2: 185.532,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAE7DC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 167.918,
  y1: 29.0952,
  x2: 174.261,
  y2: 32.1073,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 177.993,
  y1: 23.2773,
  x2: 184.337,
  y2: 26.2897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 188.068,
  y1: 17.4599,
  x2: 194.411,
  y2: 20.4721,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 72.7021,
  y1: 46.6037,
  x2: 143.263,
  y2: 93.7314,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAE7DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAE7DC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 117.592,
  y1: 91.1469,
  x2: 329.756,
  y2: 232.851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAE7DC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 234.631,
  y1: 76.4141,
  x2: 240.974,
  y2: 79.4261,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 244.706,
  y1: 70.5967,
  x2: 251.049,
  y2: 73.609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 254.781,
  y1: 64.7793,
  x2: 261.124,
  y2: 67.7915,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 139.416,
  y1: 93.923,
  x2: 209.977,
  y2: 141.051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAE7DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAE7DC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 184.307,
  y1: 138.465,
  x2: 396.47,
  y2: 280.169,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAE7DC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 301.348,
  y1: 123.732,
  x2: 307.691,
  y2: 126.744,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 311.423,
  y1: 117.915,
  x2: 317.766,
  y2: 120.927,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 321.498,
  y1: 112.097,
  x2: 327.841,
  y2: 115.109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDD6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 206.132,
  y1: 141.241,
  x2: 276.693,
  y2: 188.369,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAE7DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAE7DC"
})));

function SvgSubscribeCardsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 364,
    viewBox: "0 0 337 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeCardsIcon);
export default __webpack_public_path__ + "static/media/subscribe-cards-icon.1965ca18.svg";
export { ForwardRef as ReactComponent };